// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"485a76f4","453":"0644e7a3"}[chunkId] + ".chunk.js";
};